/* eslint-disable react/require-default-props,react/destructuring-assignment */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class LocalizationContextWrapper extends PureComponent {
  static propTypes = {
    intl: PropTypes.object.isRequired,
    children: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.array,
      PropTypes.node,
      PropTypes.number,
      PropTypes.string,
    ]),
  };

  static childContextTypes = {
    intl: PropTypes.object,
  };

  getChildContext() {
    return {
      intl: this.props.intl,
    };
  }

  render() {
    const { children } = this.props;

    if (!children) return null;

    if (Array.isArray(children)) {
      return <div>{children}</div>;
    }

    // unnecessary wrapper brokes layout (for empty state for example)
    return children;
  }
}



// WEBPACK FOOTER //
// ./src/components/common/LocalizationContextWrapper/index.jsx